export const guidelinesRoute = () => '/legal'
